import { jsx as _jsx } from "react/jsx-runtime";
const SvgLolDrake = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 11,
	height: 10,
	viewBox: "0 0 11 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.0884 3.2H8.32928V0.6L6.37473 2.6L5.20201 0L4.02928 2.6L2.07473 0.6V3.2H0.315643L2.07473 5C2.07473 5 1.68383 7.2 2.85655 7.6C4.02928 8 4.61564 10 4.61564 10H5.00655H5.39746H5.78837C5.78837 10 6.37473 8 7.54746 7.6C8.72019 7.2 8.32928 5 8.32928 5L10.0884 3.2ZM4.63128 6.7H4.50033C4.32051 6.7 4.1446 6.636 4.00778 6.514C3.66573 6.212 3.06569 5.558 3.06569 4.7C3.06569 4.7 3.87682 4.938 4.34005 5.32C4.52378 5.472 4.62933 5.702 4.62933 5.946V6.7H4.63128ZM6.50765 6.514C6.37083 6.636 6.19687 6.7 6.0151 6.7H5.88414V5.946C5.88414 5.704 5.98969 5.474 6.17342 5.32C6.63664 4.936 7.44778 4.7 7.44778 4.7C7.44974 5.558 6.84969 6.212 6.50765 6.514Z",
		fill: "currentColor"
	})
});
export default SvgLolDrake;
